/**
 * Canonical client_session_id for the current WebApp runtime (one tab/run).
 *
 * We intentionally keep a single canonical storage key, but we also
 * migrate legacy keys used by older code paths:
 * - analytics/tracker.ts used:  aicams_session_id_v1
 * - monitoring/errors.ts used: aicams_client_session_id
 */
function uuidv4(): string {
  try {
    return crypto.randomUUID()
  } catch {
    // eslint-disable-next-line no-bitwise
    const s4 = () => Math.floor((1 + Math.random()) * 0x10000).toString(16).slice(1)
    return `${s4()}${s4()}-${s4()}-4${s4().slice(1)}-a${s4().slice(1)}-${s4()}${s4()}${s4()}`
  }
}

const KEY = 'aicams_client_session_id'
const LEGACY_KEYS = ['aicams_session_id_v1'] as const
let cached: string | null = null

export function getClientSessionId(): string {
  if (cached) return cached
  try {
    const ss = sessionStorage
    const existing = String(ss.getItem(KEY) || '').trim()
    if (existing && existing.length >= 8) {
      cached = existing
      return existing
    }
    // Migrate legacy keys if present.
    for (const lk of LEGACY_KEYS) {
      const v = String(ss.getItem(lk) || '').trim()
      if (v && v.length >= 8) {
        ss.setItem(KEY, v)
        cached = v
        return v
      }
    }
    const next = uuidv4()
    ss.setItem(KEY, next)
    cached = next
    return next
  } catch {
    const next = uuidv4()
    cached = next
    return next
  }
}

